// Angular
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

// Libraries
import objectPath from 'object-path';
import { Observable, takeUntil } from 'rxjs';
import { Select } from '@ngxs/store';

// Services
import { LayoutConfigService } from '../../services/layout-config.service';

// Store
import { StorageState } from '../../state/storage.state';

// Models
import { AppCleanup } from '../../models';

@Component({
	selector: 'brand',
	templateUrl: './brand.component.html',
	styleUrl: './brand.component.scss',
})
export class BrandComponent extends AppCleanup implements OnInit, OnDestroy {
	@Select(StorageState.currentRoute) currentRoute$: Observable<string>;
	@Select(StorageState.darkMode) darkMode$: Observable<boolean>;
	@Input() collapsed: boolean;
	@Input() center: boolean = false;
	@Input() desktop: boolean = false;

	selectedLogo: string;
	logoDark: string;
	logoLight: string;
	primaryColor: string;
	atHome: boolean;

	constructor(
		private layoutConfigService: LayoutConfigService,
		private router: Router
	) {
		super();
	}

	ngOnInit() {
		this.layoutConfigService.localLayoutConfig$.pipe(takeUntil(this.destroy)).subscribe((layoutConfig) => {
			if (layoutConfig) {
				this.primaryColor = objectPath.get(layoutConfig, 'loader.color');
				this.logoDark = objectPath.get(layoutConfig, 'self.logo.dark');
				this.logoLight = objectPath.get(layoutConfig, 'self.logo.light');

				this.darkMode$.pipe(takeUntil(this.destroy)).subscribe((darkMode) => {
					if (darkMode) {
						this.selectedLogo = this.logoLight;
					} else {
						this.selectedLogo = this.logoDark;
					}
				});
			}
		});

		this.currentRoute$.pipe(takeUntil(this.destroy)).subscribe((currentRoute) => {
			if (currentRoute === '/' || currentRoute === '/job') {
				this.atHome = true;
			} else {
				this.atHome = false;
			}
		});
	}

	ngOnDestroy() {
		super.ngOnDestroy();
	}

	goHome() {
		if (!this.atHome) {
			this.router.navigate([`/`]);
		}
	}
}
